import {loadableReady} from '@loadable/component'
import {createBrowserHistory} from 'history'
import React from 'react'
import {hydrate} from 'react-dom'
import {Provider} from 'react-redux'
import {renderRoutes} from 'react-router-config'
import {Router} from 'react-router-dom'

import App from '~/App'
import {i18nInitPromise} from '~/lib/i18n'
import getRoutes from '~/routes'
import {createStore} from '~/stores'

import PendingNavDataLoader from './PendingNavDataLoader'

import './index.css'

// 纯官网暂时不启用sentry
// sentry()

const history = createBrowserHistory()
export {history}

// 在创建store时添加类型检查
const initialState =
  typeof window.APP_INITIAL_STATE === 'object' && window.APP_INITIAL_STATE
    ? window.APP_INITIAL_STATE
    : undefined
const store = createStore(initialState)
window.store = store
window.APP_INITIAL_STATE = null
const routes = getRoutes(store)

const application = (
  <Provider store={store}>
    <Router history={history}>
      <PendingNavDataLoader store={store} routes={routes}>
        {() => <App>{renderRoutes(routes)}</App>}
      </PendingNavDataLoader>
    </Router>
  </Provider>
)

loadableReady(async () => {
  await i18nInitPromise

  const root = document.getElementById('app')
  hydrate(application, root)
})
